export const mixinValid = {
    data() {
        return {
            // 按钮在用于提交数据时，初始状态为数据未通过校验状态，默认置灰
            // 由于校验组件校验有延时，所有会有一闪而过的颜色变幻效果
            // 一秒后再置空避免出现此问题，性能略有损耗
            btnCls: 'disabled'
        }
    },
    methods: {
        validForm() {
            return new Promise((resolve) => {
                const me = this,
                    form = me.$refs.form;
                form.validate().then(res => {
                    if (res) {
                        resolve();
                    } else {
                        // 延迟执行，否则首次验证时找不到错误信息
                        setTimeout(() => {
                            const error = form.errors;
                            let data;
                            for (const item in error) {
                                data = error[item];
                                if (data.length) {
                                    me.toast.fail(data[0]);
                                    break;
                                }
                            }
                        }, 100)
                    }
                });
            });
        },
        // 根据验证状态获取验证状态
        getBtnCls(v) {
            return v ? 'disabled' : this.btnCls;
        }
    },
    mounted() {
        // console.log('mounted');
        // 一秒后移除css
        setTimeout(() => {
            this.btnCls = '';
        }, 1000)
    }
}